<template>
  <div>
    <p>{{payload.content}}</p>
    <a @click="activateCompanyEmployee" class="button is-info">Activate Company Employee</a>
  </div>
</template>
<script>
export default {
  name: 'activate-company-employee',
  props: ['payload'],
  methods: {
    activateCompanyEmployee () {
      this.$network_utils.updateCompanyEmployee({ id: this.payload.resource_id, status: 'active' }).then(() => {
        this.$utils.emit('show_toast', { text: 'Company Employee Activated' })
      })
    }
  }
}
</script>
